/**
 * This wrapper module is needed so we can stub the functions in solana-gateway-ts
 * without running into the 'Descriptor for property is non-configurable and non-writable' error.
 */
import * as gatewayTs from "@identity.com/solana-gateway-ts";
export const { findGatewayToken } = gatewayTs;
